import isFunction from 'lodash/isFunction';

import { freeTrialLengthWithTrialPeriodKeys } from 'src/common/constants/subscription/products';

export function getFreeTrialLengthWithPeriodLocalizationsKeys(isMonthlyTrial) {
  return isMonthlyTrial
    ? freeTrialLengthWithTrialPeriodKeys.months
    : freeTrialLengthWithTrialPeriodKeys.days;
}

// Used to create a localized string, which consists of a freeTrialLength + trialPeriod (i.e 3 days)
export function createFreeTrialLengthWithTrialPeriod(
  getLocalizedText,
  freeTrialLength,
  isMonthlyTrial,
) {
  const numFreeTrialLength = parseInt(freeTrialLength, 10);

  if (!Number.isNaN(numFreeTrialLength) && isFunction(getLocalizedText)) {
    const isTrialPeriodPlural = numFreeTrialLength > 1;
    const freeTrialLengthWithPeriodSelectedKeys =
      getFreeTrialLengthWithPeriodLocalizationsKeys(isMonthlyTrial);

    return getLocalizedText(
      isTrialPeriodPlural
        ? freeTrialLengthWithPeriodSelectedKeys.plural
        : freeTrialLengthWithPeriodSelectedKeys.singular,
      {
        freeTrialLength: numFreeTrialLength,
      },
    );
  }
}
